import {
  TAppGroup,
} from '@/types/app-type.ts';

export const appTileColorMap: Record<TAppGroup, string> = {
  ProductionPlanning: 'var(--category-production-planning)',
  Operations: 'var(--category-operations)',
  QualityAssurance: 'var(--category-quality-assurance)',
  Analytics: 'var(--category-analytics)',
  MasterData: 'var(--category-master-data)',
  Administration: 'var(--category-administration)',
  Operation: 'var(--category-operation)',
  Data: 'var(--category-data)',
  Maintenance: 'var(--category-maintenance)',
  Process: 'var(--category-process)',
  Configuration: 'var(--category-configuration)',
};
